import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';


/**
 * This component can be used to overlay contents on an element/component
 * It uses content projection to get the content to be overlaid
 *
 * Basic usage:
 * <div class="parent">
 *  <sp-overlay>
 *    // content to be overlaid
 *  </sp-overlay>
 * <div>
 *
 * The projected contents will take the full width, height of the div with class of `parent`.
 * Parent should have relative position and display set to flex
 */
@Component({
  selector: 'sp-overlay',
  templateUrl: './overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayComponent implements OnChanges {
  /**
   * List of default classes
   */
  private defaultClasses = 'absolute h-full w-full flex justify-center items-center';

  /**
   * For binding css classes with host element
   */
  @HostBinding('className') classList = this.defaultClasses;

  /**
   * Any other classes that needs to be applied to the host element
   */
  @Input() class!: string;

  ngOnChanges() {
    this.classList = this.defaultClasses;
    if (this.class) {
        this.classList += ` ${this.class}`;
    }
  }
}
